import { render, staticRenderFns } from "./BillCopy.vue?vue&type=template&id=71abae8e&"
import script from "./BillCopy.vue?vue&type=script&lang=js&"
export * from "./BillCopy.vue?vue&type=script&lang=js&"
import style0 from "./BillCopy.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports